import { OrganizationDetailsModel } from './organization-details.model';
import { OrganizationUserModel } from './organization-user.model';
import { ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { OrganizationFormGroupName } from '../constants';
import { ListQueryParam } from '../../../../../common/constants';

export class OrganizationBrief {
  id?: number;
  active: boolean;
  organizationName: string;
  country: string;
  city: string;
  streetName: string;
  streetNumber: string;
  zipCode: string;
}

export class OrganizationModel extends OrganizationBrief {
  masterOfRoles: boolean;
  hasMasterOfRolesUsers: boolean;
  constructor(params?: OrganizationModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class OrganizationFormValueModel {
  [OrganizationFormGroupName.Details]: OrganizationDetailsModel;
  [OrganizationFormGroupName.AdminUser]?: OrganizationUserModel;
  [OrganizationFormGroupName.MasterOfRoles]?: OrganizationUserModel;
}

export class OrganizationItemModel extends OrganizationModel {
  users: OrganizationUserModel[] = [];

  constructor(params?: OrganizationFormValueModel) {
    super();
    if (params) {
      if (params[OrganizationFormGroupName.AdminUser]) {
        this.users.push(params[OrganizationFormGroupName.AdminUser]);
      }
      if (params[OrganizationFormGroupName.MasterOfRoles]) {
        this.users.push(params[OrganizationFormGroupName.MasterOfRoles]);
      }
      Object.assign(this, params[OrganizationFormGroupName.Details]);
    }
  }
}

export class OrganizationListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: OrganizationListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
